function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesAirConditionerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.686 15.5H28V4.687H4V15.5h2.313v-3.201a1 1 0 011-1h17.373a1 1 0 011 1v3.2zm-1.998 0H8.313v-2.201h15.374v2.2zM3 2.687h26a1 1 0 011 1V16.5a1 1 0 01-1 1H3a1 1 0 01-1-1V3.687a1 1 0 011-1zm13.544 18.01a2.012 2.012 0 000 2.841 4.013 4.013 0 010 5.67h-2.319c.196-.516.492-1 .905-1.415a2.012 2.012 0 000-2.84 4.013 4.013 0 010-5.67h2.32c-.194.515-.491 1-.905 1.414zm-5 2.841a2.012 2.012 0 010-2.84c.415-.415.711-.9.905-1.415H10.13a4.013 4.013 0 000 5.67 2.012 2.012 0 010 2.84c-.413.414-.71.9-.904 1.414h2.318a4.013 4.013 0 000-5.669zm10-2.84a2.012 2.012 0 000 2.84 4.013 4.013 0 010 5.67h-2.319c.195-.516.491-1 .905-1.415a2.012 2.012 0 000-2.84 4.013 4.013 0 010-5.67h2.32c-.194.515-.491 1-.905 1.414z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesAirConditionerFilled;